module.exports = __webpack_public_path__ + "img/김동우 아티스트.d3021203.jpg";